import { render, staticRenderFns } from "./ExploreFoods.vue?vue&type=template&id=30276e93&"
import script from "./ExploreFoods.vue?vue&type=script&lang=js&"
export * from "./ExploreFoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports